import React from "react";
import { BsTrash } from "react-icons/bs";

export const FavoriteProducts = () => {
  return (
    <div className="w-full my-4 lg:w-[70%] lg:px-6 lg:py-6">
      <h1 className="font-semibold text-[28px] md:text-[32px]">Favourite Products (3)</h1>
      <p className="py-2 font-extralight w-3/4 text-lg">
        These are products that you have saved because you like them. If you no
        longer want this, click the heart icon again to undo your action.
      </p>

      <div className="flex flex-col md:flex-row gap-4 pt-6">
        <div className="w-full md:w-80">
          {/* <div className="w-full h-60 rounded-xl  mb-2" /> */}
          <img className="rounded-lg mb-3 w-full" src="https://cdn.dribbble.com/userupload/11991189/file/original-6cbc6028edb89aa42a8f4f08c8d9e608.png?resize=450x338&vertical=center" alt="" />
          <div className=" flex justify-between items-center">
            <h1 className="font-semibold">Savory Food UI Kit</h1>
            <BsTrash className="border dark:border-[#5B5B5B] p-2 rounded-lg text-3xl text-[#FF6F6F]" />
          </div>
          <p>$120</p>
        </div>
        <div className="w-full md:w-80">
        <img className="rounded-lg mb-3 w-full" src="https://cdn.dribbble.com/userupload/11991189/file/original-6cbc6028edb89aa42a8f4f08c8d9e608.png?resize=450x338&vertical=center" alt="" />
          <div className=" flex justify-between items-center">
            <h1 className="font-semibold">Savory Food UI Kit</h1>
            <BsTrash className="border dark:border-[#5B5B5B] p-2 rounded-lg text-3xl text-[#FF6F6F]" />
          </div>
          <p>$120</p>
        </div>
        <div className="w-full md:w-80">
        <img className="rounded-lg mb-3 w-full" src="https://cdn.dribbble.com/userupload/11991189/file/original-6cbc6028edb89aa42a8f4f08c8d9e608.png?resize=450x338&vertical=center" alt="" />
          <div className=" flex justify-between items-center">
            <h1 className="font-semibold">Savory Food UI Kit</h1>
            <BsTrash className="border dark:border-[#5B5B5B] p-2 rounded-lg text-3xl text-[#FF6F6F]" />
          </div>
          <p>$120</p>
        </div>
      </div>
    </div>
  );
};
